var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompressedAir1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17C14.5 18.65 13.15 20 11.5 20C9.85 20 8.5 18.65 8.5 17H10.5C10.5 17.55 10.95 18 11.5 18C12.05 18 12.5 17.55 12.5 17C12.5 16.45 12.05 16 11.5 16H2V14H11.5C13.15 14 14.5 15.35 14.5 17ZM19 6.5C19 4.57 17.43 3 15.5 3C13.57 3 12 4.57 12 6.5H14C14 5.67 14.67 5 15.5 5C16.33 5 17 5.67 17 6.5C17 7.33 16.33 8 15.5 8H2V10H15.5C17.43 10 19 8.43 19 6.5ZM18.5 11H2V13H18.5C19.33 13 20 13.67 20 14.5C20 15.33 19.33 16 18.5 16V18C20.43 18 22 16.43 22 14.5C22 12.57 20.43 11 18.5 11Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17C14.5 18.65 13.15 20 11.5 20C9.85 20 8.5 18.65 8.5 17H10.5C10.5 17.55 10.95 18 11.5 18C12.05 18 12.5 17.55 12.5 17C12.5 16.45 12.05 16 11.5 16H2V14H11.5C13.15 14 14.5 15.35 14.5 17ZM19 6.5C19 4.57 17.43 3 15.5 3C13.57 3 12 4.57 12 6.5H14C14 5.67 14.67 5 15.5 5C16.33 5 17 5.67 17 6.5C17 7.33 16.33 8 15.5 8H2V10H15.5C17.43 10 19 8.43 19 6.5ZM18.5 11H2V13H18.5C19.33 13 20 13.67 20 14.5C20 15.33 19.33 16 18.5 16V18C20.43 18 22 16.43 22 14.5C22 12.57 20.43 11 18.5 11Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressedAir1);
export default __webpack_public_path__ + "static/media/Compressed Air-1.95eba462c8138d893fd1f222a32774cd.svg";
export { ForwardRef as ReactComponent };